/**
 * @file Post event to native app to request notification permission
 */
import { REQUEST__PERMISSION_CAMERA } from '../../constants';
import { postMessageToNative } from '../../helpers/postMessageToNative';

/**
 * Post event to native app to request notification permission
 */
const postPermissionCameraEvent = (): void => {
  postMessageToNative({
    eventName: REQUEST__PERMISSION_CAMERA,
  });
};

export default postPermissionCameraEvent;
